/**
 * Fragment de routes du paquet v2-p06-ecrans-profils (vague V2). Composants chargés à la demande (règle de chargement
 * du registre). Routes NEUVES : `/org/acces` (couvert par `organisation-profils` dans son YAML) n'est PAS remplacé, car
 * il porte aussi les règles d'accès et la revue des refus, écrans de V8b non encore réalisés (décision du paquet) ;
 * l'onglet « Profils » de l'accès y conduit après leur réalisation.
 *  - `/org/profils` → organisation-profils ;
 *  - `/org/profils/creer` → organisation-profil-editeur (création) ;
 *  - `/org/profils/:profilId` → organisation-profil-fiche ;
 *  - `/org/profils/:profilId/editeur` → organisation-profil-editeur (révision la plus récente).
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const OrganisationProfils = lazy(() => import('../ecrans/v2/profils/OrganisationProfils'))
const FicheProfil = lazy(() => import('../ecrans/v2/profils/FicheProfil'))
const EditeurProfil = lazy(() => import('../ecrans/v2/profils/EditeurProfil'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

function creation({ session, t }: ContexteRoutes): JSX.Element {
  return (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <EditeurProfil session={session} profilId={null} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v2-profils',
  routes: [
    { chemin: '/org/profils', element: ecran(OrganisationProfils) },
    { chemin: '/org/profils/creer', element: creation },
    { chemin: '/org/profils/:profilId', element: ecran(FicheProfil) },
    { chemin: '/org/profils/:profilId/editeur', element: ecran(EditeurProfil) },
  ],
}
